import React from 'react';

import ActionTileView from '../ActionTile.View';
import {LobbyActionModel} from './LobbyAction.model';

export default React.memo(function LobbyActionView({
  label,
  hint,
  disabled,
  onPress,
}: LobbyActionModel) {
  return (
    <ActionTileView
      testID="v2-action-lobby"
      icon="home"
      label={label}
      hint={hint}
      disabled={disabled}
      onPress={onPress}
    />
  );
});
